import { ApiService } from './api.services';
import { BaseService } from 'app/core/base.service';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { WebGrupoNotificacao } from '../models/webGrupoNotificacao.model';

export class WebGrupoNotificacaoService extends ApiService implements BaseService<WebGrupoNotificacao>{
    
    private strAction = 'api/WebGrupoNotificacao';
    
    constructor(
        httpClient: HttpClient,
        private route: Router) {
        super(httpClient, route);
        }

        getAll(): Observable<WebGrupoNotificacao[]> {
            return this.get<WebGrupoNotificacao[]>(this.strAction + `/GetAll`);
        }

        deleteById(idPessoa: number) {
            return this.post(this.strAction + `/DeleteById?id=${idPessoa}`);
        }
    
        Post(WebGrupoNotificacao: WebGrupoNotificacao ): Observable<WebGrupoNotificacao[]>{
            return this.post<WebGrupoNotificacao[]>(this.strAction + `/Post`, WebGrupoNotificacao);
        }

}